// val是以秒为单位的，如10.31表示10.31秒
export const formatTime = val => {
    let second: any = Math.floor(val);
    let minute: any = Math.floor(second / 60); // 得到分钟数
    second = second % 60;
    if (second < 10) {
        second = `0${second}`;
    }
    if (minute < 10) {
        minute = `0${minute}`;
    }
    return `${minute}:${second}`;
};
